import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EBookRoutingModule } from './e-book-routing.module';
import { AddEbookComponent } from './add-ebook/add-ebook.component';
import {CoreCommonModule} from '../../../@core/common.module';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EBookComponent} from './e-book.component';


@NgModule({
  declarations: [AddEbookComponent],
    imports: [
        CommonModule,
        EBookRoutingModule,
        CoreCommonModule,
        CoreDirectivesModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [ AddEbookComponent]
})
export class EBookModule { }
